(() => {
  'use strict';
  if (window.upvcSupportInitialised) return;
  window.upvcSupportInitialised = true;

  const revealAnchor = () => {
    let id;
    try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (_) { return; }
    if (!id) return;
    const target = document.getElementById(id);
    if (!target || !target.closest('.upvc-support')) return;
    let parent = target;
    while (parent) {
      if (parent.tagName === 'DETAILS') parent.open = true;
      parent = parent.parentElement;
    }
    target.scrollIntoView({ block: 'start' });
  };

  // Highlights the contents link for the section currently in view. Purely
  // presentational: links work without it and nothing is hidden or moved.
  const trackContents = (nav) => {
    if (typeof window.IntersectionObserver !== 'function') return;
    const links = [...nav.querySelectorAll('a[href^="#"]')];
    const targets = links.map((link) => document.getElementById(decodeURIComponent(link.getAttribute('href').slice(1)))).filter(Boolean);
    if (!targets.length) return;
    const visible = new Set();
    const update = () => {
      const current = targets.find((target) => visible.has(target)) || null;
      links.forEach((link) => {
        const active = current && link.getAttribute('href') === `#${current.id}`;
        if (active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    };
    const observer = new window.IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target); });
      update();
    }, { rootMargin: '-20% 0px -60% 0px' });
    targets.forEach((target) => observer.observe(target));
  };

  function initialise(scope = document) {
    scope.querySelectorAll('[data-upvc-support-print]').forEach((button) => {
      if (button.dataset.supportReady) return;
      button.dataset.supportReady = 'true';
      button.hidden = false;
      button.addEventListener('click', () => window.print());
    });
    scope.querySelectorAll('[data-upvc-support-nav]').forEach((nav) => {
      if (nav.dataset.supportReady) return;
      nav.dataset.supportReady = 'true';
      trackContents(nav);
    });
    revealAnchor();
  }

  let printState = [];
  window.addEventListener('beforeprint', () => {
    printState = [...document.querySelectorAll('.upvc-support details')].map((element) => [element, element.open]);
    printState.forEach(([element]) => { element.open = true; });
  });
  window.addEventListener('afterprint', () => {
    printState.forEach(([element, open]) => { element.open = open; });
    printState = [];
  });
  window.addEventListener('hashchange', revealAnchor);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
})();
